import React, { useState, useCallback, useRef, useLayoutEffect } from 'react'
import styled from '@emotion/styled'
import Button from '@material-ui/core/Button'
import ShareIcon from '@material-ui/icons/Share'
import Clipboard from 'clipboard'
import { CommmuneTextBlue } from 'src/components/shared/CssValues'

const useClipboardText = (onCopySuccess, copiedText) => {
  const buttonRef = useRef(null)

  useLayoutEffect(() => {
    const cb = new Clipboard(buttonRef.current, {
      text: () => copiedText
    })
    cb.on('success', () => {
      onCopySuccess()
    })
    cb.on('error', e => {
      console.error(e)
    })
    return () => {
      cb.destroy()
    }
  }, [])
  return { buttonRef }
}

const CopyTitleAndLinkButton = ({ copiedText, value }) => {
  const [isCopied, setCopied] = useState(false)
  const onCopySuccess = useCallback(() => {
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 1000)
  }, [])
  const { buttonRef } = useClipboardText(onCopySuccess, copiedText)
  return (
    <ButtonWrapper>
      <Button buttonRef={buttonRef}>
        {isCopied ? (
          <ButtonStyle>コピーが完了しました</ButtonStyle>
        ) : (
          <ButtonStyle>
            {value} <ShareIcon />
          </ButtonStyle>
        )}
      </Button>
    </ButtonWrapper>
  )
}

const ButtonStyle = styled.div`
  display: flex;
  color: ${CommmuneTextBlue};
  font-weight: bold;
  background: #ffffff;
  margin-right: 0;
  border: 2px solid ${CommmuneTextBlue};
  padding: 10px;
  border-radius: 6px;
`

const ButtonWrapper = styled.div`
  text-align: center;
  margin: 15px 0;
`

export default CopyTitleAndLinkButton
